<template>
  <div v-if="!workshops.length">
    <p class="font-mono uppercase text-brand-green text-[16px]">Mastermind skupina</p>
    <div class="w-[250px] text-[14px] pt-3">
      <p>Zapište se a zúčastněte se jedné z mastermind skupin nebo networkingu</p>
    </div>
  </div>
  <div class="flex" v-if="!workshops.length">
    <a
      class="flex self-end items-center w-full justify-center px-4 py-3 mt-4 group text-[14px] hover:opacity-80 text-black font-mono bg-brand-green border border-brand-green hover:border-brand-green hover:text-brand-green hover:bg-brand-gray-700 hover:cursor-pointer group"
      href="/#workshopy">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="mr-3 group-hover:hidden">
        <path d="M2.66699 9.33464V8.0013H7.33366V9.33464H2.66699ZM2.66699 6.66797V5.33464H10.0003V6.66797H2.66699ZM2.66699 4.0013V2.66797H10.0003V4.0013H2.66699ZM8.66699 13.3346V11.2846L12.3503 7.61797C12.4503 7.51797 12.5614 7.44575 12.6837 7.4013C12.8059 7.35686 12.9281 7.33464 13.0503 7.33464C13.1837 7.33464 13.3114 7.35964 13.4337 7.40964C13.5559 7.45964 13.667 7.53464 13.767 7.63464L14.3837 8.2513C14.4725 8.3513 14.542 8.46241 14.592 8.58464C14.642 8.70686 14.667 8.82908 14.667 8.9513C14.667 9.07352 14.6448 9.19852 14.6003 9.3263C14.5559 9.45408 14.4837 9.56797 14.3837 9.66797L10.717 13.3346H8.66699ZM9.66699 12.3346H10.3003L12.317 10.3013L12.017 9.98464L11.7003 9.68464L9.66699 11.7013V12.3346ZM12.017 9.98464L11.7003 9.68464L12.317 10.3013L12.017 9.98464Z" fill="black"/>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="mr-3 group-hover:block hidden">
        <path d="M2.66699 9.33464V8.0013H7.33366V9.33464H2.66699ZM2.66699 6.66797V5.33464H10.0003V6.66797H2.66699ZM2.66699 4.0013V2.66797H10.0003V4.0013H2.66699ZM8.66699 13.3346V11.2846L12.3503 7.61797C12.4503 7.51797 12.5614 7.44575 12.6837 7.4013C12.8059 7.35686 12.9281 7.33464 13.0503 7.33464C13.1837 7.33464 13.3114 7.35964 13.4337 7.40964C13.5559 7.45964 13.667 7.53464 13.767 7.63464L14.3837 8.2513C14.4725 8.3513 14.542 8.46241 14.592 8.58464C14.642 8.70686 14.667 8.82908 14.667 8.9513C14.667 9.07352 14.6448 9.19852 14.6003 9.3263C14.5559 9.45408 14.4837 9.56797 14.3837 9.66797L10.717 13.3346H8.66699ZM9.66699 12.3346H10.3003L12.317 10.3013L12.017 9.98464L11.7003 9.68464L9.66699 11.7013V12.3346ZM12.017 9.98464L11.7003 9.68464L12.317 10.3013L12.017 9.98464Z" fill="#9EFC4E"/>
      </svg>
      Vybrat aktivitu
    </a>

  </div>
  <div v-else class="w-full">
    <p v-if="hasNetworking()" class="font-mono uppercase text-brand-green text-[16px]">Řízený networking</p>
    <p v-else class="font-mono uppercase text-brand-green text-[16px]">Mastermind skupina</p>
    <div class="m-auto">
      <ProgramCardModal
        :programArticle="selectedProgramArticle"
        @close="clearSelectedArticle"
      />
      <!--    <p class="text-brand-gray-900 text-big-body font-medium mb-3">-->
      <!--      Počet přihlášených workshopů: {{ Object.keys(workshopsMutable).length }}-->
      <!--    </p>-->

      <ProgramCard
        class="mt-4"
        :userLoggedIn="true"
        :isWorkshop="true"
        :programArticle="workshopsMutable[workshopKey]"
        v-for="workshopKey in Object.keys(workshopsMutable)"
        :key="workshopKey"
        :workshopRegistrationState="workshopRegistrationState"
        @unRegisterWorkshop="unRegisterWorkshop"
        @clicked="selectProgramArticle"
        :workshopRegistrationOpened="true"
      />
    </div>
  </div>
<!--  <div class="max-w-[630px]">-->
<!--    <ProgramCardModal-->
<!--      :programArticle="selectedProgramArticle"-->
<!--      @close="clearSelectedArticle"-->
<!--    />-->
<!--&lt;!&ndash;    <p class="text-brand-gray-900 text-big-body font-medium mb-3">&ndash;&gt;-->
<!--&lt;!&ndash;      Počet přihlášených workshopů: {{ Object.keys(workshopsMutable).length }}&ndash;&gt;-->
<!--&lt;!&ndash;    </p>&ndash;&gt;-->

<!--    <ProgramCard-->
<!--      class="mt-4"-->
<!--      :userLoggedIn="true"-->
<!--      :isWorkshop="true"-->
<!--      :programArticle="workshopsMutable[workshopKey]"-->
<!--      v-for="workshopKey in Object.keys(workshopsMutable)"-->
<!--      :key="workshopKey"-->
<!--      :workshopRegistrationState="workshopRegistrationState"-->
<!--      @unRegisterWorkshop="unRegisterWorkshop"-->
<!--      @clicked="selectProgramArticle"-->
<!--      :workshopRegistrationOpened="true"-->
<!--    />-->
<!--  </div>-->
<!--  -->
<!--  <p v-if="maxWorkshopRegistrationsPerUser <= workshopsMutable.length" class="text-brand-gray-500 mt-4">Můžete se zúčastnit jen {{ maxWorkshopRegistrationsPerUser }} {{ maxWorkshopRegistrationsPerUser === 1 ? 'workshopu' : 'workshopů'}}. Chcete-li si vybrat jiný, musíte se nejdříve z jednoho přihlášeného workshopu odhlásit.</p>-->

<!--  <a-->
<!--    v-if="maxWorkshopRegistrationsPerUser > workshopsMutable.length"-->
<!--    class="-->
<!--      flex-->
<!--      items-center-->
<!--      mt-4-->
<!--      font-medium-->
<!--      text-button text-brand-blue-->
<!--      hover:opacity-80-->
<!--    "-->
<!--    :href="route('frontend.homepage') + '#workshopy'"-->
<!--  >-->
<!--    <svg-->
<!--      class="mr-2"-->
<!--      width="24"-->
<!--      height="24"-->
<!--      viewBox="0 0 24 24"-->
<!--      fill="none"-->
<!--      xmlns="http://www.w3.org/2000/svg"-->
<!--    >-->
<!--      <path-->
<!--        d="M11.9882 2.48935C11.7895 2.49245 11.6001 2.57432 11.4617 2.71696C11.3232 2.85959 11.2471 3.05135 11.2499 3.25009V11.2501H3.24994C3.15056 11.2487 3.05188 11.267 2.95966 11.3041C2.86743 11.3412 2.78349 11.3962 2.71271 11.466C2.64194 11.5358 2.58573 11.6189 2.54737 11.7106C2.50901 11.8023 2.48926 11.9007 2.48926 12.0001C2.48926 12.0995 2.50901 12.1979 2.54737 12.2896C2.58573 12.3813 2.64194 12.4644 2.71271 12.5342C2.78349 12.604 2.86743 12.659 2.95966 12.6961C3.05188 12.7331 3.15056 12.7515 3.24994 12.7501H11.2499V20.7501C11.2485 20.8495 11.2669 20.9481 11.304 21.0404C11.341 21.1326 11.396 21.2165 11.4658 21.2873C11.5356 21.3581 11.6188 21.4143 11.7104 21.4527C11.8021 21.491 11.9005 21.5108 11.9999 21.5108C12.0993 21.5108 12.1977 21.491 12.2894 21.4527C12.3811 21.4143 12.4643 21.3581 12.5341 21.2873C12.6038 21.2165 12.6589 21.1326 12.6959 21.0404C12.733 20.9481 12.7513 20.8495 12.7499 20.7501V12.7501H20.7499C20.8493 12.7515 20.948 12.7331 21.0402 12.6961C21.1324 12.659 21.2164 12.604 21.2872 12.5342C21.3579 12.4644 21.4141 12.3813 21.4525 12.2896C21.4909 12.1979 21.5106 12.0995 21.5106 12.0001C21.5106 11.9007 21.4909 11.8023 21.4525 11.7106C21.4141 11.6189 21.3579 11.5358 21.2872 11.466C21.2164 11.3962 21.1324 11.3412 21.0402 11.3041C20.948 11.267 20.8493 11.2487 20.7499 11.2501H12.7499V3.25009C12.7514 3.14971 12.7327 3.05006 12.6949 2.95705C12.6571 2.86403 12.601 2.77955 12.53 2.70861C12.4589 2.63767 12.3744 2.5817 12.2813 2.54404C12.1883 2.50638 12.0886 2.48778 11.9882 2.48935Z"-->
<!--        fill="#2699C6"-->
<!--      />-->
<!--    </svg>-->
<!--    Zapsat se na workshop-->
<!--  </a>-->
</template>

<script>
import ProgramCard from "../Program/ProgramCard.vue";
import ProgramCardModal from "../Program/ProgramCardModal.vue";
import axios from "axios";

export default {
  components: {
    ProgramCard,
    ProgramCardModal,
  },

  data() {
    return {
      workshopRegistrationState: {
        user_registrations: [],
      },
      workshopsMutable: {},
      selectedProgramArticle: null,
    };
  },
  props: {
    workshops: {
      type: Array,
      default: () => [],
    },
    maxWorkshopRegistrationsPerUser: {
      type: Number,
    },
  },

  methods: {
    selectProgramArticle(article) {
      this.selectedProgramArticle = article;
    },
    clearSelectedArticle() {
      this.selectedProgramArticle = undefined;
    },
    async unRegisterWorkshop(workshopId) {
      try {
        const res = await axios.delete(
          `/api/workshop/${workshopId}/registration`,
          {}
        );

        this.workshopRegistrationState = res.data;

        this.workshopsMutable = this.workshopsMutable.filter(
          (w) => w.id !== workshopId
        );
      } catch (err) {}
    },
    hasNetworking() {
      for (let workshop of this.workshops) {
        if(workshop.id === 13){
          return true;
        }
      }

      return false;
    },
  },

  created() {
    this.workshopsMutable = this.workshops;

    for (let workshop of this.workshopsMutable) {
      this.workshopRegistrationState.user_registrations.push(workshop.id);
    }
  },
};
</script>

<style>
</style>
